class WHeader extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.burger = this.querySelector('.w-header__burger');
    this.drawer = this.querySelector('.w-header__drawer');
    if (!this.burger || !this.drawer) return;

    const { signal } = this.controller;
    this.burger.addEventListener('click', () => this.openDrawer(), { signal });
    this.drawer.querySelectorAll('[data-drawer-close]').forEach((el) =>
      el.addEventListener('click', () => this.closeDrawer(), { signal })
    );
    this.drawer.querySelector('.w-header__drawer-cta')?.addEventListener('click', (event) => {
      this.closeDrawer();
      const href = event.currentTarget.getAttribute('href') || '';
      const hash = href.indexOf('#');
      if (hash < 0) return;
      const target = document.getElementById(href.slice(hash + 1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.drawer.classList.contains('is-open')) this.closeDrawer();
    }, { signal });
  }

  disconnectedCallback() {
    this.closeDrawer();
    this.controller?.abort();
  }

  openDrawer() {
    requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    this.burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('w-header-drawer-open');
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.burger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('w-header-drawer-open');
  }
}

customElements.define('w-header', WHeader);
